/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1179
 */

var r = require(/* 2517 */"./2517")
var i = require(/* 1445 */"../../2546/1456/1445")
var /* [auto-meaningful-name] */Object$prototype$propertyIsEnumerable = Object.prototype.propertyIsEnumerable
var /* [auto-meaningful-name] */Object$getOwnPropertySymbols = Object.getOwnPropertySymbols
var s = Object$getOwnPropertySymbols ? function (e) {
  return null == e ? [] : (e = Object(e), r(Object$getOwnPropertySymbols(e), function (t) {
    return Object$prototype$propertyIsEnumerable.call(e, t)
  }))
} : i
module.exports = s
